import React from "react"

export const KlaviyoFooter = (): JSX.Element => (
    <div className="klaviyo-form-TWfGgZ"></div>
)
